import dynamic from 'next/dynamic'

export const FAQ = dynamic(() => import('./faq'))
